import React, { useRef } from 'react';

import Cosmart1 from '../../../images/pages/cases/cosmart-ava/cosmart-1.png';
import Cosmart2 from '../../../images/pages/cases/cosmart-ava/cosmart-2.png';
import Cosmart3 from '../../../images/pages/cases/cosmart-ava/cosmart-3.png';
import Cosmart4 from '../../../images/pages/cases/cosmart-ava/cosmart-4.png';
import Cosmart5 from '../../../images/pages/cases/cosmart-ava/cosmart-5.png';

const AvaAiTrainer = () => {
    const Cosmart1Ref = useRef(null);
    const Cosmart2Ref = useRef(null);
    const Cosmart3Ref = useRef(null);
    const Cosmart4Ref = useRef(null);
    const Cosmart5Ref = useRef(null);

    return (
        <div className="cosmart-ava">
            <img src={Cosmart1} className="cosmart-ava__img cosmart-ava__img--1" alt="Case image" ref={Cosmart1Ref}/>
            <img src={Cosmart2} className="cosmart-ava__img cosmart-ava__img--2" alt="Case image" ref={Cosmart2Ref}/>
            <img src={Cosmart3} className="cosmart-ava__img cosmart-ava__img--3" alt="Case image" ref={Cosmart3Ref}/>
            <img src={Cosmart4} className="cosmart-ava__img cosmart-ava__img--4" alt="Case image" ref={Cosmart4Ref}/>
            <img src={Cosmart5} className="cosmart-ava__img cosmart-ava__img--5" alt="Case image" ref={Cosmart5Ref}/>
        </div>
    );
}

export default AvaAiTrainer;
